/**
 * ProtectedRoute — redirect to /login if not authenticated.
 * Page-level permission gating is handled by PermGate in main.tsx,
 * so no AdminRoute is needed here.
 *
 * Usage in main.tsx:
 *   <Route element={<ProtectedRoute />}>
 *     <Route path="/pulse" element={<PermGate perm="pulse"><PulseView /></PermGate>} />
 *   </Route>
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export function ProtectedRoute() {
  const { token, user } = useAuth()
  const location        = useLocation()

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
